import React from 'react'

import SlidingPanel from "react-sliding-side-panel"
import {IconButton, Switch} from "@mui/material"
import Scrollbars from "react-custom-scrollbars-2"
import Classes from "classnames"
import AddIcon from "../../components/icons/add-icon"
import CloseIcon from "../../components/icons/close-icon"
import AddForm from "./add-form"
import AddFromGoogleSheet from "./add-from-google-sheet"

// const debug = "Add"
const debug = false

type State = {
    isOpen              : boolean
    loadFromGoogleSheet : boolean
    editData            : any
}

export default class Add extends React.PureComponent<{}, State> {

    private panelId : string
    private panelSize!: number

    state: State = {
        isOpen              : false,
        loadFromGoogleSheet : false,
        editData            : null
    }

    constructor(props: {}) {
        super(props)
        this.panelId = 'add'
        this.updateSize(true)
    }

    componentDidMount() {
        window.bus.subscribe("panel:open", this, this.onPanelOpen)
        window.bus.subscribe("window-resize", this, this.updateSize)
        window.bus.subscribe("edit-point:show", this, this.onEditPointShow)
    }

    componentWillUnmount() {
        window.bus.unsubscribe(this)
    }

    updateSize = (noUpdate = false) => {
        const panelSize = window.innerWidth > 700 ? 30 : 100

        if (this.panelSize !== panelSize) {
            this.panelSize = panelSize
            if (!noUpdate) this.forceUpdate()
        }
    }

    onPanelOpen = (id: string) => {
        if (id !== this.panelId && this.state.isOpen) {
            this.setState({ isOpen: false })
        }
    }

    onToggleAdd = () => {
        const isOpen = !this.state.isOpen
        this.setState({ isOpen, editData: isOpen ? null : this.state.editData }, () => {
            if (this.state.isOpen) window.bus.triggerEvent("panel:open", this.panelId)
        })
    }

    onEditPointShow = (data: any) => {
        debug && console.log(debug, "onEditPointShow", data)
        this.setState({ isOpen: true, loadFromGoogleSheet: false, editData: data }, () => {
            window.bus.triggerEvent("panel:open", this.panelId)
        })
    }

    onFormDone = () => {
        this.setState({ isOpen: false, editData: null })
    }

    onLoadFromGoogleSheetToggle = () => {
        this.setState({ loadFromGoogleSheet: !this.state.loadFromGoogleSheet })
    }

    render() {
        debug && console.log(debug, "render", window.localSettings, window.isMobileDevice)

        const classes = Classes("add-panel", {
            'mobile-device' : window.isMobileDevice
        })

        return (
            <React.Fragment>
                <div className="add-button">
                    <IconButton size="large" color="default" onClick={this.state.editData ? this.onFormDone : this.onToggleAdd}>
                        {this.state.editData ? <CloseIcon /> : <AddIcon />}
                    </IconButton>
                </div>
                <SlidingPanel panelClassName="add-panel-container"
                              type="right"
                              noBackdrop={true}
                              isOpen={this.state.isOpen}
                              size={this.panelSize}>
                    <div className={classes}>
                        <div className="add-panel-title">{this.state.editData ? 'Редактирование точки' : 'Новая точка'}</div>
                        <Scrollbars className="add-panel-scroll">
                            {!this.state.editData &&
                                <div className="add-panel-row">
                                    <Switch className="add-panel-toggle" checked={this.state.loadFromGoogleSheet} onChange={this.onLoadFromGoogleSheetToggle}/>
                                    <div className="add-panel-label">Загрузить из csv</div>
                                </div>}

                            {this.state.loadFromGoogleSheet && !this.state.editData && <AddFromGoogleSheet/>}
                            {(!this.state.loadFromGoogleSheet || this.state.editData) &&
                                <AddForm key={this.state.editData?.id || 'new'} editData={this.state.editData} onDone={this.onFormDone}/>}
                        </Scrollbars>
                    </div>
                </SlidingPanel>
            </React.Fragment>
        )
    }
}
